/* ============================================================
   PIVOT — EDITORIAL
   Countdown, drop-row hover peek, shop-the-look pins,
   scroll progress and reveals. Cart itself is pivot.js.
   ============================================================ */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  /* ---------- countdown ---------- */
  function initCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(target)) { el.hidden = true; return; }

      var d = $('[data-cd="d"]', el), h = $('[data-cd="h"]', el),
          m = $('[data-cd="m"]', el), s = $('[data-cd="s"]', el);
      var onZero = el.getAttribute('data-countdown-done');

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          el.hidden = true;
          if (onZero) {
            var live = $(onZero);
            if (live) live.hidden = false;
          }
          clearInterval(timer);
          return;
        }
        var sec = Math.floor(diff / 1000);
        if (d) d.textContent = pad(Math.floor(sec / 86400));
        if (h) h.textContent = pad(Math.floor(sec % 86400 / 3600));
        if (m) m.textContent = pad(Math.floor(sec % 3600 / 60));
        if (s) s.textContent = pad(sec % 60);
      }
      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  /* ---------- shop-the-look pins ---------- */
  function initPins() {
    $$('.lb-shop').forEach(function (root) {
      var pins = $$('.pin', root);

      function closeAll(except) {
        pins.forEach(function (p) {
          if (p === except) return;
          p.setAttribute('aria-expanded', 'false');
          var card = document.getElementById(p.getAttribute('aria-controls'));
          if (card) card.classList.remove('on');
        });
      }

      pins.forEach(function (pin) {
        pin.addEventListener('click', function (e) {
          e.stopPropagation();
          var card = document.getElementById(pin.getAttribute('aria-controls'));
          if (!card) return;
          var open = card.classList.contains('on');
          closeAll(pin);
          card.classList.toggle('on', !open);
          pin.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });

      root.addEventListener('click', function (e) {
        if (!e.target.closest('.pin-card') && !e.target.closest('.pin')) closeAll();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('.pin-card.on').forEach(function (c) { c.classList.remove('on'); });
      $$('.pin[aria-expanded="true"]').forEach(function (p) { p.setAttribute('aria-expanded', 'false'); });
    });
  }

  /* ---------- drop rows: thumbnail tracks the cursor ---------- */
  function initPeek() {
    $$('.drop-row').forEach(function (row) {
      var peek = $('.peek', row);
      if (!peek || window.matchMedia('(hover:none)').matches) return;
      row.addEventListener('mousemove', function (e) {
        var r = row.getBoundingClientRect();
        var x = e.clientX - r.left;
        peek.style.right = 'auto';
        peek.style.left = Math.min(Math.max(x - peek.offsetWidth / 2, 12), r.width - peek.offsetWidth - 12) + 'px';
      });
    });
  }

  /* ---------- scroll progress ---------- */
  function initProgress() {
    var bar = $('.ed-progress');
    if (!bar) return;
    var tick = function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
    };
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    tick();
  }

  /* ---------- reveals ---------- */
  function initReveal() {
    var all = function () { $$('.ed-reveal').forEach(function (el) { el.classList.add('in'); }); };
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      all(); return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0 });
    $$('.ed-reveal').forEach(function (el) { io.observe(el); });
    setTimeout(all, 3000);   /* failsafe — content can never stay hidden */
  }

  /* ---------- bag link label ---------- */
  function initBagLabel() {
    var link = $('.bag-link');
    if (!link) return;
    var count = $('.cart-count', link);
    if (!count) return;
    var sync = function () { count.hidden = count.textContent === '0'; };
    sync();
    new MutationObserver(sync).observe(count, { childList: true, characterData: true, subtree: true });
  }

  function init() {
    initCountdowns();
    initPins();
    initPeek();
    initProgress();
    initReveal();
    initBagLabel();
    document.addEventListener('shopify:section:load', function () {
      initCountdowns(); initPins(); initPeek(); initReveal();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
